import React from 'react';
import StaticPageTemplate from '../components/ui/StaticPageTemplate';
import PDFLink from '../components/ui/PDFLink';
import styled from 'styled-components';
import { newsPageQuery } from '../queries';

const Section = styled.section`
  margin-bottom: 3rem;
`;

const SectionTitle = styled.h2`
  color: #2E5984;
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
`;

const Paragraph = styled.p`
  margin-bottom: 1rem;
  line-height: 1.6;
  white-space: pre-line;
`;

const PDFGrid = styled.div`
  display: grid;
  gap: 1rem;
  margin-top: 1.5rem;
`;

const News = () => {
  const defaultData = {
    title: "News",
    subtitle: "Latest updates from Tandara Lodge",
    introText: "Download our latest news in PDF format below."
  };

  const customContent = (pageData) => (
    <>
      {/* Tandara Tattles Section */}
      <Section>
        <SectionTitle>Tandara Tattles</SectionTitle>
        {pageData && pageData.newsItems && pageData.newsItems.length > 0 ? (
          <PDFGrid>
            {pageData.newsItems.map((item, index) => (
              <PDFLink
                key={index}
                title={item.newsTitle}
                description="Latest newsletter from Tandara Lodge"
                pdfUrl={item.documentUrl || `/src/assets/pdfs/Tandara_Tattles_Issue_23.pdf`}
              />
            ))}
          </PDFGrid>
        ) : (
          <PDFGrid>
            <PDFLink
              title="Tandara Tattles - Issue 23"
              description="Latest newsletter from Tandara Lodge"
              pdfUrl="/src/assets/pdfs/Tandara_Tattles_Issue_23.pdf"
            />
          </PDFGrid>
        )}
      </Section>

      {/* Financial Reports Section */}
      <Section>
        <SectionTitle>
          {pageData?.financialReportsHeader || "Financial Reports"}
        </SectionTitle>
        {pageData?.financialReportsText && (
          <Paragraph>{pageData.financialReportsText}</Paragraph>
        )}
        {pageData && pageData.financialReports && pageData.financialReports.length > 0 ? (
          <PDFGrid>
            {pageData.financialReports.map((report, index) => (
              <PDFLink
                key={index}
                title={report.reportTitle}
                description="Annual financial report"
                pdfUrl={report.documentUrl}
              />
            ))}
          </PDFGrid>
        ) : (
          <PDFGrid>
            <PDFLink
              title="Tandara Financial Report 2024"
              description="Annual financial report for 2024"
              pdfUrl="/src/assets/pdfs/Tandara_Financial_Report_-_2024_-_web.pdf"
            />
            <PDFLink
              title="Annual Report 2023-2024"
              description="Comprehensive annual report for 2023-2024"
              pdfUrl="/src/assets/pdfs/Annual_Report_2023-2024.pdf"
            />
          </PDFGrid>
        )}
      </Section>
    </>
  );

  return (
    <StaticPageTemplate
      pageName="newsPage"
      query={newsPageQuery}
      defaultData={defaultData}
      customContent={customContent}
    />
  );
};

export default News;
